import { Component, OnInit } from '@angular/core';
import { LearnService } from './learn.service';
import { ComponentFactoryResolver, ViewChild, ViewContainerRef } from '@angular/core';
import { DynamicMessageComponent } from '../../components/dynamicMessage/dynamicMessage.component';
import { AES, mode, pad, enc } from 'crypto-js';
import { CacheService } from '../../services/cache-service';
import { AuthService } from '../../services/auth.service';
import { LearnMessage } from '../../entities/chat-message.module';
import { combineLatest, Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { TokenLog } from '../../entities/token-log.model';
import { head } from 'ramda';

@Component({
  selector: 'app-learn',
  templateUrl: './learn.component.html',
  styleUrls: ['./learn.component.css'],
  providers: [LearnService]
})

export class LearnComponent implements OnInit {

  message: LearnMessage;
 

  wordTypeList: any;

  userName: string;
  userId: string;

  timer: any;

  domainId: string;

  showWaiting: boolean = false;
  resultMsg: string;

  urllink: string;


  @ViewChild('content', { read: ViewContainerRef }) content: ViewContainerRef;
  constructor(public componentFactory: ComponentFactoryResolver,
  public mychatroomService: LearnService,
  private authService:AuthService, private readonly router: Router) {
  }



  ngOnInit() {
    this.message = new LearnMessage();
    this.wordTypeList =  init_wordTypeList();
    this.authService.userInfo$.subscribe((userInfo)=>{
      this.userName = userInfo.userLoginId;
      this.domainId = userInfo.domainId;
      this.userId = userInfo.userId;
      this.message.userName = userInfo.currentUserName;
      this.message.userId = userInfo.userId;
      this.message.loginId = userInfo.userLoginId;
      this.message.domainId = userInfo.domainId;
    });
  }

  getLearningTypeList(): any{
    this.wordTypeList =  init_wordTypeList();
    return 1;
  }

  submitOneRow(index: number){
    var learningType = document.getElementById('col'+index+"100")['value'];

    var val0 = document.getElementById('col'+index+"0")['value'];
    var val1 = document.getElementById('col'+index+"1")['value'];
    var vobj = document.getElementById('col'+index+"2");
    var val2 = vobj?vobj['value']:null;

    if(learningType=='WORD'){
      this.message.titleContent=val0;
      this.message.contentType=val1;
    }else if(learningType=='STEP' || learningType=='STORY'){
      this.message.titleContent=val0;
      this.message.mainContent1=val1;
    } else if(learningType=='KEFU'){
      this.message.mainContent1=val0;
      this.message.mainContent2=val1;
      this.message.targetFile = document.getElementById('col'+index+"3")['value'];
      this.message.contentType=val2;
    } else if(learningType=='KEFU2'){
      this.message.contentType=val0;
      this.message.mainContent1=val1;
      this.message.targetFile = val2;
    }
  
    this.message.learningType = learningType;

    this.urllink = 'learning';

    // if(index==0){
    //   this.message.msgActionType='Add.Word';
    //   this.message.keyPrefix = "learnWord";
    // }else if(index==1){
    //   this.message.msgActionType='Add.Step';
    //   this.message.keyPrefix = "learnStepContent";
    // }else if(index==2){
    //   this.message.msgActionType='Add.Story';
    //   this.message.keyPrefix = "learnStory";
    // }else if(index==3){
    //   this.message.msgActionType='Add.Kefu';
    //   this.message.keyPrefix = "learnKefu";
    // }else if(index==4){
    //   this.message.msgActionType='Add.Kefu2';
    //   this.message.keyPrefix = "learnKefu2";
    // }else if(index==100){
    //   this.message.msgActionType='Add.Rule';
    //   this.message.keyPrefix = "learnRule";
    // }

    this.process();
  }



  process(counter:number = 0): void {
    // if (this.message.content.trim() === '') {
    //   return;
    // }
    if(counter>=3){
      this.router.navigate(['/login']);
      return;
    }
    if(this.message.userId==null || this.message.userId=='null'){
      this.router.navigate(['/login']);
    }else{
      var rxSubscriber:Observable<TokenLog> =
      this.authService.checkTokenAndRefresh();

      if(rxSubscriber){
        rxSubscriber.subscribe((aa)=>{
          this.sendMsgOut();
        })
      }else{
        this.sendMsgOut();
      }
    }
  
 
  }

  sendMsgOut(){
    const component = this.componentFactory.resolveComponentFactory(DynamicMessageComponent);
    // component.inputs.push({propName: 'dd', templateName: 'ss'});
    const com = this.content.createComponent(component);
    const tm = this.getNowTime();
    com.instance.userName = "你";//this.userName;
    com.instance.sendTime = tm;
    this.message.dateTime = tm;

   this.start();
   this.mychatroomService.sendMessage2JackExt(this.message, this);
   
  //  this.message.content = '';
  }

  start(){
    this.showWaiting = true;
    this.resultMsg = "... ...";
  }

  done(response: any, isHavingErr:boolean = false){
    this.showWaiting = false;
    this.resultMsg = isHavingErr?"Done With Error":"Done";
  }
  

  getNowTime(): string {
    var dd = new Date();
    var y = dd.getFullYear();
    var m = dd.getMonth();
    var d = dd.getDate();
    var h = dd.getHours(); 
    var mi = dd.getMinutes(); 
    var s = dd.getSeconds();
    var nyr = y+"-"+(m+1)+"-"+d;
    return nyr+" "+(h<10?('0'+h):(h)) + ':' + (mi<10?('0'+mi):(mi)) + ':' + (s<10?('0'+s):(s));
  }
 
  logout(): void{
    this.authService.logout(this.userId);
  }
}
